// Config adapter: the single registry of feature-flag keys, so callers reference FLAGS.*
// instead of magic strings.
export const FLAGS = {
  // Per-surface render gate (App).
  assistantDtEnabled: 'magic-apron-assistant-dt-enabled',
  assistantMwEnabled: 'magic-apron-assistant-mw-enabled',
  assistantAppEnabled: 'magic-apron-assistant-app-enabled',
  assistantB2bEnabled: 'magic-apron-assistant-b2b-enabled',

  // JOURNEY SWITCH (App): opts INTO the consolidated journey; absence resolves `legacy`.
  assistantUnifiedEnabled: 'isLiveChatUnificationEnabled',

  assistantUnifiedAppEnabled: 'isLiveChatUnificationAppEnabled',

  // Config-driven page exclusion (App), from MAG4-815 on master. When the rules flag is
  // off, the legacy allow-list gate (`getIsLegacyCompatiblePage`) applies instead.
  exclusionRulesEnabled: 'magic-apron-assistant-enable-exclusion-rules',
  excludedPages: 'magic-apron-assistant-excluded-pages',

  // OPS KILL SWITCH for the liveAgent block, read in useResolvedJourney — see
  // .claude/context/journey-resolution.md.
  liveAgentEnabled: 'magic-apron-assistant-live-agent-enabled',

  // Dynamic initial suggested questions (useMessageHistory).
  dynamicIsqMasterEnabled: 'magic-apron-initial-suggested-questions-enabled',
  dynamicIsqDtEnabled: 'magic-apron-dynamic-isq-dt-enabled',
  dynamicIsqMwEnabled: 'magic-apron-dynamic-isq-mw-enabled',
  dynamicIsqAppEnabled: 'magic-apron-dynamic-isq-app-enabled',
  dynamicIsqB2bEnabled: 'magic-apron-dynamic-isq-b2b-enabled',
};
